// extracted by mini-css-extract-plugin
export var errorIcon = "_ls-1";
export var nameLogo = "_ls-0";